import axios from 'axios';
import { message } from 'ant-design-vue';
import { getOssSignature } from '@/api/api';

const imgCdnPrefix = process.env.VUE_APP_OSS_IMG;

export interface OssUploadFile {
  file: File | Blob;
  name: string;
}

function generateRandomString(length = 10): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let index = 0; index < length; index++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

function getExtension(fileName: string): string {
  const parts = fileName.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
}

export async function uploadFileToOss(fileData: OssUploadFile): Promise<string> {
  try {
    const ossRes: any = await getOssSignature();
    const { policy, accessid, callback, signature, host, dir } = ossRes.data;
    const extension = getExtension(fileData.name);
    const uploadType = `${generateRandomString(10)}.${extension}`;
    const key = `${dir}${Date.now()}_${uploadType}`;
    const formData = new FormData();

    formData.append('key', key);
    formData.append('policy', policy);
    formData.append('OSSAccessKeyId', accessid);
    formData.append('success_action_status', '200');
    formData.append('callback', callback);
    formData.append('signature', signature);
    formData.append('name', extension);
    formData.append('file', fileData.file);

    const res: any = await axios({
      url: `https://${host}`,
      data: formData,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    if (res.status === 200) {
      return imgCdnPrefix + key;
    }

    throw new Error('OSS回调失败');
  } catch (err) {
    message.error('上传失败，请稍后重试');
    throw err;
  }
}
